import store from '@/stores/store';
import { ModuleContext } from '@/stores/moduleConst';

export const useRefreshToken = () => {
  /**
   * Hàm đăng ký sự kiện khi refresh token thay đổi
   * NHANH3 20.02.2025
   */
  const subscribeSyncRefreshToken = () => {
    const eventId = 'auth_data';
    window.addEventListener('storage', (e) => {
      if (e.key === eventId && e.newValue) {
        const newAuthData = JSON.parse(e.newValue);

        const context = store.state[ModuleContext];
        
        // Nếu dữ liệu token thay đổi có cùng databaseId thì mới cập nhật token
        if (context?.DatabaseId === newAuthData.DatabaseId) {
          store.dispatch(`${ModuleContext}/refreshToken`, newAuthData);
        }

        // Nhận được xong thì xóa luôn 
        localStorage.removeItem(eventId);
      }
    });
  }

  /**
   * Hàm set auth data vào local storage
   * @param {*} authData 
   * NHANH3 20.02.2025
   */
  const setAuthData = (authData) => { 
    // Gán thêm databaseId vào authData để kiểm tra xem tab có cùng database không mới cập nhật
    const context = store.state[ModuleContext];
    if (context?.DatabaseId) {
      authData.DatabaseId = context.DatabaseId;
    }
    localStorage.setItem('auth_data', JSON.stringify(authData));
  }

  /**
   * Hàm xóa auth data khỏi local storage
   * NHANH3 20.02.2025
   */
  const removeAuthData = () => { 
    localStorage.removeItem('auth_data');
  }

  return {
    subscribeSyncRefreshToken,
    setAuthData,
    removeAuthData,
  };
}